(function () {
  // England & Wales bank holidays 2025–2027
  var bankHolidays = [
    '2025-01-01','2025-04-18','2025-04-21','2025-05-05',
    '2025-05-26','2025-08-25','2025-12-25','2025-12-26',
    '2026-01-01','2026-04-03','2026-04-06','2026-05-04',
    '2026-05-25','2026-08-31','2026-12-25','2026-12-28',
    '2027-01-01','2027-03-26','2027-03-29','2027-05-03',
    '2027-05-31','2027-08-30','2027-12-27','2027-12-28'
  ];

  function isBlocked(date) {
    var day = date.getDay();
    if (day === 0 || day === 6) return true;
    var iso = date.getFullYear() + '-'
      + String(date.getMonth() + 1).padStart(2, '0') + '-'
      + String(date.getDate()).padStart(2, '0');
    return bankHolidays.indexOf(iso) !== -1;
  }

  function nextAvailable(date) {
    var d = new Date(date);
    while (isBlocked(d)) d.setDate(d.getDate() + 1);
    return d;
  }

  // Count n working days forward from date (not including date itself)
  function addWorkingDays(date, n) {
    var d = new Date(date);
    var count = 0;
    while (count < n) {
      d.setDate(d.getDate() + 1);
      if (!isBlocked(d)) count++;
    }
    return d;
  }

  // Friendly date formatting, e.g. "Tues 12 August 2026"
  var DAY_NAMES = ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'];
  var MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'];

  function formatFriendly(date) {
    if (!date || isNaN(date.getTime())) return '';
    return DAY_NAMES[date.getDay()] + ' ' + date.getDate() + ' '
      + MONTH_NAMES[date.getMonth()] + ' ' + date.getFullYear();
  }

  // Parse a stored "d/m/Y" value (e.g. "23/07/2026") back into a Date
  function parseDMY(str) {
    var m = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec((str || '').trim());
    if (!m) return null;
    return new Date(parseInt(m[3], 10), parseInt(m[2], 10) - 1, parseInt(m[1], 10));
  }

  // Update any "Scheduling a gift for …" echo that lives near this input
  // (used by the cart drawer gift block). `date` is a Date object.
  function updateGiftEcho(input, date) {
    var scope = input.closest('.sb-cart-extras') || document;
    var echoes = scope.querySelectorAll('.js-delivery-date-echo');
    var friendly = formatFriendly(date);
    for (var i = 0; i < echoes.length; i++) {
      echoes[i].textContent = friendly
        ? friendly
        : (echoes[i].dataset.placeholder || 'your chosen date');
    }
  }

  function initInput(input, minDate) {
    if (!input || input._flatpickr) return; // already initialised on this element

    // When the field lives inside the cart drawer, render the calendar inline
    // (static) so it stays within the drawer. Otherwise the calendar is appended
    // to <body>, and the drawer's focus-trap treats a date click as an "outside
    // click" and closes the drawer.
    var inDrawer = !!input.closest('#mini-cart');

    flatpickr(input, {
      minDate: minDate,
      dateFormat: 'd/m/Y',
      disableMobile: true,
      disable: [isBlocked],
      static: inDrawer,
      onChange: function (selectedDates) {
        updateGiftEcho(input, selectedDates[0]);
      }
    });

    // Reflect any pre-existing value (e.g. saved cart attribute) into the echo.
    if (input.value) updateGiftEcho(input, parseDMY(input.value));

    // Make the whole "Deliver on" box open the calendar, not just the input.
    var field = input.closest('.sb-deliver__field');
    if (field && !field._sbClickBound) {
      field._sbClickBound = true;
      field.addEventListener('click', function (event) {
        if (event.target !== input && input._flatpickr) {
          input._flatpickr.open();
        }
      });
    }
  }

  function init() {
    // Cart-page field (#delivery-date) and any drawer fields (.js-delivery-date)
    var inputs = document.querySelectorAll('#delivery-date, .js-delivery-date');
    if (!inputs.length) return;

    var now = new Date();
    var day = now.getDay();
    var isFridayAfterCutoff = (day === 5 && now.getHours() >= 12);

    // Determine the start date — the day the order can first be dispatched.
    // Friday after 1pm, weekends and bank holidays all push to the next working day.
    var startDate = new Date(now);

    if (isFridayAfterCutoff) {
      // After 1pm Friday treat as Saturday, then find next working day (Monday)
      startDate.setDate(startDate.getDate() + 1);
      startDate = nextAvailable(startDate);
    } else if (isBlocked(startDate)) {
      // Weekend or bank holiday — start from next working day
      startDate = nextAvailable(startDate);
    }
    // else: a normal working day before any cutoff — start from today

    // Earliest delivery = 2 working days from the start date
    var minDate = addWorkingDays(startDate, 2);

    for (var i = 0; i < inputs.length; i++) {
      initInput(inputs[i], minDate);
    }
  }

  // Observe the <html> element (never replaced by instant.page) so the
  // observer survives body swaps and fires whenever new nodes are added.
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        init();
        return;
      }
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    init();
    observer.observe(document.documentElement, { childList: true, subtree: true });
  });
})();
